// extracted by mini-css-extract-plugin
export default {"ad-anchor":"ImageOnly_ad-anchor__dUv1g","cta-container__link":"ImageOnly_cta-container__link__BMVkd"};